import React from 'react';
import { Link } from 'react-router-dom';

export default function ProductsGridSection() {
  const products = [
    {
      title: "Mutual Funds (MF)",
      subtitle: "SIPs & direct plans",
      link: "/products/mutual-funds",
      bgImage: "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?auto=format&fit=crop&q=80&w=600",
      imgStyle: "object-cover object-center"
    },
    {
      title: "Specialized Investment Funds (SIF)",
      subtitle: "Focused strategies",
      link: "/products/sif",
      bgImage: "sif.png", // Placeholder image for SIF
      imgStyle: "object-cover object-center"
    },
    {
      title: "Portfolio Management Services (PMS)",
      subtitle: "Managed portfolios",
      link: "/products/pms",
      // PMS: Professional desk analytics centered cleanly
      bgImage: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=600",
      imgStyle: "object-cover object-top"
    },
    {
      title: "Fixed Deposits (FD)",
      subtitle: "Stable, insured returns",
      link: "/products/bonds-fds",
      // Fixed Deposit: Clear Piggy Bank / Savings concept
      bgImage: "https://images.unsplash.com/photo-1579621970795-87facc2f976d?auto=format&fit=crop&q=80&w=600",
      imgStyle: "object-cover object-center"
    },
    {
      title: "Alternate Investment Funds (AIF)",
      subtitle: "Category I, II & III",
      link: "/products/aif",
      bgImage: "https://images.unsplash.com/photo-1610375461246-83df859d849d?auto=format&fit=crop&q=80&w=600",
      imgStyle: "object-cover object-center"
    },
    {
      title: "International / Offshore Platforms",
      subtitle: "Global diversification",
      link: "/products/offshore",
      bgImage: "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?auto=format&fit=crop&q=80&w=600",
      imgStyle: "object-cover object-center"
    },
    {
      title: "Pre-IPO Unlisted Opportunities",
      subtitle: "Early-stage access",
      link: "/products/pre-ipo",
      bgImage: "pre-ipo.png", // Placeholder image for Pre-IPO
      // Object contain with dark bg prevents text cropping on Pre-IPO banner
      imgStyle: "object-cover object-center"
    },
    {
      title: "Bonds / NCDs",
      subtitle: "Fixed-income ladder",
      link: "/products/bonds-fds",
      bgImage: "https://tse3.mm.bing.net/th/id/OIP.hayt6WTwuTQAV2UuuCUY3AHaEI?r=0&w=5308&h=2966&rs=1&pid=ImgDetMain&o=7&rm=3",
      imgStyle: "object-cover object-center"
    }
  ];

  return (
    <section className="py-16 px-6 max-w-7xl mx-auto font-sans">
      
      {/* Section Header */}
      <div className="text-center space-y-3 mb-12">
        <h2 className="font-serif-title text-3xl sm:text-4xl font-bold text-[#0A2540]">
          Invest in <span className="italic text-[#16325B] font-normal">everything</span> that matters
        </h2>
        <p className="text-gray-500 text-xs sm:text-sm max-w-xl mx-auto">
          From your first SIP to pre-IPO opportunities — one relationship across every asset class.
        </p>
      </div>

      {/* 8 Clean Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {products.map((item, index) => (
          <Link
            key={index}
            to={item.link}
            className="group bg-white rounded-2xl overflow-hidden border border-gray-200/80 shadow-sm hover:shadow-xl hover:border-[#16325B]/50 transition-all duration-300 flex flex-col justify-between"
          >
            <div>
              {/* Increased Height to h-44 for Proper Ratio */}
              <div className="h-44 w-full overflow-hidden bg-gray-100 relative">
                <img 
                  src={item.bgImage} 
                  alt={item.title} 
                  className={`w-full h-full ${item.imgStyle} group-hover:scale-105 transition-transform duration-500`}
                />
              </div>

              {/* Card Title & Content */}
              <div className="p-5 space-y-1">
                <h3 className="font-serif-title text-lg font-bold text-[#0B2540] group-hover:text-[#16325B] transition-colors leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-gray-500 font-medium">
                  {item.subtitle}
                </p>
              </div>
            </div>

            {/* Bottom Row CTA Button */}
            <div className="px-5 pb-5 pt-2 flex items-center justify-end">
              <div className="inline-flex items-center gap-1.5 text-[#16325B] font-bold text-xs group-hover:translate-x-1 transition-transform">
                <span>Explore More</span>
                <span>→</span>
              </div>
            </div>

          </Link>
        ))}
      </div>

    </section>
  );
}